<template>
    <v-container>
        <v-row>
            <v-col>
                <h1>Oops!</h1>
                <h3>Cette page n'existe pas (ou plus).</h3>
                <router-link :to="{name: 'products-list'}">Retour à la page de réservation</router-link>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
  export default {
    props: {
      resource: {
        type: String,
        required: true
      }
    }
  }
</script>
